
import React from 'react'
import { MdOutlinePlayCircleFilled } from 'react-icons/md'


import {Input} from "@nextui-org/react";
import {IoSearchOutline} from "react-icons/io5";

function SearchComponent(props: any) {
  const { register } = props

  return (
    <div className="z-50 absolute w-full h-full">
      <div className="bg-[#232326] opacity-80 transition-all w-full h-full relative bottom-0 right-0 left-0 top-0 z-50"></div>
      <div className="bg-white w-[368px]  p-2 top-0 right-0 transition-all h-full fixed z-50">
        <div className="flex justify-between  p-3">
          <h1 className="font-normal opacity-60">ARA</h1>
          <button className="rounded-full  justify-end hover:bg-stone-300">
            <MdOutlinePlayCircleFilled size={24} />
          </button>
        </div>
        <div className="">
      <Input
        label=""
        isClearable
        radius="lg"
        classNames={{
          label: "text-black/50 dark:text-white/90",
          input: [
            "bg-transparent",
            "text-black/90 dark:text-stone-400",
            "placeholder:text-default-700/50 dark:placeholder:text-white/60",
          ],
          innerWrapper: "bg-transparent",
          inputWrapper: [
            
            "bg:shadow-xl",
            "bg-default-stone-400",
            "dark:bg-default/60",
            "backdrop-blur-xl",
            "backdrop-saturate-200",
            "hover:bg-default-200/70",
            "dark:hover:bg-default/70",
            "group-data-[focused=true]:bg-default-200/50",
            "dark:group-data-[focused=true]:bg-default/60",
            "!cursor-text",
          ],
        }}
        placeholder="Proje/ Kullanıcı Ara..."
        startContent={
          <IoSearchOutline className="text-black/50 dark:text-white/90 text-slate-400 pointer-events-none flex-shrink-0" />
        }
      />
    </div>
      </div>
    </div>
  )
}
export default SearchComponent
